import { Bell, LogOut, Search } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center justify-between gap-3 border-b border-slate-200 bg-white px-3 shadow-sm sm:h-16 sm:gap-4 sm:px-6">
      <div className="min-w-0 flex-1 max-w-md">
        <div className="relative hidden sm:block">
          <Search className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input
            type="text"
            placeholder="جستجو..."
            className="w-full rounded-lg border border-slate-200 bg-slate-50 py-2 pl-4 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>
        <p className="truncate text-sm font-semibold text-slate-900 sm:hidden">
          پنل مدیریت
        </p>
      </div>

      <div className="flex shrink-0 items-center gap-2 sm:gap-4">
        <button
          type="button"
          className="relative hidden rounded-lg p-2 text-slate-600 transition-colors hover:bg-slate-50 sm:inline-flex"
          aria-label="اعلان‌ها"
        >
          <Bell className="h-5 w-5" />
          <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-red-500" />
        </button>

        <div className="flex items-center gap-2 border-r border-slate-200 pr-2 sm:gap-3 sm:pr-4">
          <div className="hidden text-right sm:block">
            <p className="text-sm font-medium text-slate-900">{user?.name}</p>
            <p className="text-xs text-slate-500">مدیر سیستم</p>
          </div>
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-indigo-500 text-xs font-bold text-white">
            {user?.name?.charAt(0) ?? 'ا'}
          </div>
        </div>

        <button
          type="button"
          onClick={logout}
          className="rounded-lg p-2 text-slate-600 transition-colors hover:bg-red-50 hover:text-red-600"
          aria-label="خروج"
        >
          <LogOut className="h-5 w-5" />
        </button>
      </div>
    </header>
  );
}
